import { cloudfrontURL, baseURL } from '../utils/url-builder';

export default {
  install(Vue) {
    Vue.prototype.$cloudfrontURL = cloudfrontURL;
    Vue.prototype.$baseURL = baseURL;
  },
};
